import { hasParent } from "../hasParent.mjs";
export var isFocusInside = function isFocusInside(topNode, actualActiveElement) {
  var activeElement = actualActiveElement || document.activeElement;
  var nodes = Array.isArray(topNode) ? topNode : [topNode];
  return nodes.some(function (node) {
    return hasParent(activeElement, node);
  });
};
//# sourceMappingURL=isFocusInside.mjs.map